import React from 'react';
import { Card } from 'antd';

const ProductsCreate: React.FC = () => {
  return (
    <Card title="创建商品">
      创建商品页面
    </Card>
  );
};

export default ProductsCreate;
